import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { ym } from '../../lib/dayUtil'
import StoreNewsPage from '../news/StoreNewsPage'

function StoreNews({group}) {
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const yearmonth = query.get('yearmonth');
  const sub = query.get("sub");
  const [period, setPeriod] = useState(null);
  const navigate = useNavigate();

  useEffect(()=> {
    if(yearmonth) {
      //数字の20で始まりハイフンが入り２文字の数字かどうか
      const ym_regex = new RegExp(/^2[0-9]{3}-([0-9]{2})$/);
      if(ym_regex.test(yearmonth)){
        let yearmonth_ = yearmonth;
        const ym_ = yearmonth_.split("-");
        if(ym_[0] <2020){
          //window.alert("カレンダーは2020年以降になります。1");
          yearmonth_ = ym(new Date());
          navigate("/");
        }
        setPeriod(yearmonth_);
      }
    }
  }, [yearmonth, sub])
  return <StoreNewsPage period={period} group={group} sub={sub}/>
}

export default StoreNews;
